import React, { FC } from 'react';
import { ReactComponent as Link } from '../../../assets/Links/links.svg';

export const LinkIcon: FC = () => <Link />;
